import * as React from "react";
import { useDispatch } from "react-redux";
import { Typography, Stack, Icon, Button, Paper } from "@mui/material";
import { format as DateFormat } from "date-fns";
import PropTypes from "prop-types";
import SwiperCard from "../../components/SwipperCard";
import { Guardar } from "../../redux/actions/dias";
import Consulta from "./consulta";

const Feriados = (props) => {
  const { listado, params, color } = props;
  const dispatch = useDispatch();

  const [dia, setDia] = React.useState(null);
  return (
    <>
      {listado &&
        listado.map((f) => (
          <SwiperCard
            card={
              <Paper
                sx={{
                  p: 1,
                  backgroundColor: color.main,
                  border: "1px solid " + color.sText,
                }}
              >
                <Stack direction="row">
                  <Icon
                    sx={{
                      ml: 0.5,
                      mr: 2,
                      color: color.sText,
                    }}
                    fontSize="large"
                  >
                    insert_invitation
                  </Icon>

                  <Stack sx={{ flexGrow: 1 }}>
                    <Stack direction="row">
                      <Typography
                        variant="caption"
                        sx={{ color: color.pText, flexGrow: 1 }}
                      >
                        {DateFormat(new Date(f.Fecha), "dd/MM/yyyy HH:00")}
                      </Typography>
                      <Typography variant="caption" sx={{ color: color.sText }}>
                        {f.Dias + " día" + (f.Dias > 1 ? "s" : "")}
                      </Typography>
                    </Stack>
                    <Typography
                      variant="caption"
                      sx={{ lineBreak: "nowrap", color: color.pText }}
                    >
                      {f.Texto}
                    </Typography>
                  </Stack>
                </Stack>
              </Paper>
            }
            wrapperStart={null}
            wrapperEnd={
              <Stack
                height="100%"
                sx={{
                  backgroundColor: (theme) => theme.palette.primary.main,
                }}
              >
                <Button
                  sx={{
                    backgroundColor: (theme) => theme.palette.primary.main,
                    height: "100%",
                  }}
                  variant="contained"
                  size="small"
                  onClick={() => setDia(f)}
                >
                  Guardar
                </Button>
              </Stack>
            }
          />
        ))}
      <Consulta
        open={Boolean(dia) || false}
        onClose={() => {
          setDia(null);
        }}
        onSave={() => {
          dispatch(
            Guardar({
              Conductor: params.conductor,
              Dia: dia.Id,
              Token: params.token,
            }),
          );
          setDia(null);
        }}
        fecha={(dia && DateFormat(new Date(dia.Fecha), "dd/MM/yyyy")) || ""}
      />
    </>
  );
};
Feriados.propTypes = {
  listado: PropTypes.array,
  params: PropTypes.object,
  color: PropTypes.object,
};
export default Feriados;
